import { WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR } from "@/constants";
import { WISHLIST_WIDGET_NAMES } from "@/constants/widget-names";
import { ModalManager } from "@/modal-manager";
import { SaveForLaterModalWidgetDefinition } from "@apps/wishlist/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";
import { parseOptionalBooleanDataAttr } from "@ui-utils/Injector/utils";

import { LoggerInterface } from "@interfaces/LoggerInterface";

class SaveForLaterModalWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly modalManager: ModalManager,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector
    ) {}

    start() {
        this.logger.debug("SaveForLaterModalWidgetInjector.start", {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger.debug(
                "SaveForLaterModalWidgetInjector found placeholder",
                { placeholder }
            );

            void (async () => {
                const SaveForLaterModalWidget =
                    await this.dynamicImportManager.importDefault(
                        SaveForLaterModalWidgetDefinition,
                        true
                    );

                const widget = new SaveForLaterModalWidget(
                    {
                        target: placeholder,
                        isWidgetShadowRootEnabled: parseOptionalBooleanDataAttr(
                            placeholder,
                            WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR
                        ),
                    },
                    this.logger,
                    this.modalManager
                );

                await widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(
                        WISHLIST_WIDGET_NAMES.SAVE_FOR_LATER_MODAL_WIDGET
                    )
                );

                dispatchSdkEvent(
                    new WidgetInjectedSdkEvent(
                        WISHLIST_WIDGET_NAMES.SAVE_FOR_LATER_MODAL_WIDGET
                    )
                );
            })();
        });
    }
}

export default SaveForLaterModalWidgetInjector;
